import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../../utils/apiConfig';

/**
 * BlockedList - Widget "Blocages à confirmer" pour Planificateur
 */
const BlockedList = ({ token, onNavigate }) => {
  const [blocages, setBlocages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlocages = async () => {
      if (!token) return;

      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/dashboard/blocked-prestations`,
          {
            headers: { 'Authorization': `Bearer ${token}` }
          }
        );

        if (!response.ok) throw new Error('Erreur de chargement');

        const data = await response.json();
        setBlocages(data.success ? data.data : []);
      } catch (err) {
        console.error('Erreur fetch blocages:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlocages();
  }, [token]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>Blocages à confirmer</h4>
        <div style={styles.loading}>Chargement...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>Blocages à confirmer</h4>
        <div style={styles.error}>{error}</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h4 style={styles.title}>
          Blocages à confirmer
          {blocages.length > 0 && (
            <span style={styles.count}>({blocages.length})</span>
          )}
        </h4>
        <button
          style={styles.viewButton}
          onClick={() => onNavigate && onNavigate('planning')}
        >
          Voir blocages
        </button>
      </div>

      {blocages.length === 0 ? (
        <div style={styles.empty}>
          <span style={styles.emptyIcon}>📋</span>
          <p style={styles.emptyText}>Aucun blocage en attente</p>
        </div>
      ) : (
        <div style={styles.list}>
          {blocages.slice(0, 5).map((blocage) => (
            <div key={blocage.id} style={styles.blocageItem}>
              <span style={styles.badge}>B</span>
              <div style={styles.blocageInfo}>
                <span style={styles.prestationNumber}>{blocage.prestation_number}</span>
                <span style={styles.clientName}>{blocage.client_name || '—'}</span>
                <span style={styles.date}>{formatDate(blocage.start_date)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  title: {
    margin: 0,
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#1a1a2e',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  count: {
    backgroundColor: '#ffc107',
    color: '#000',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '0.85rem',
    fontWeight: '500'
  },
  viewButton: {
    background: 'none',
    border: 'none',
    color: '#6366f1',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500'
  },
  loading: {
    textAlign: 'center',
    padding: '30px',
    color: '#6c757d'
  },
  error: {
    padding: '20px',
    backgroundColor: '#fff5f5',
    borderRadius: '8px',
    color: '#dc3545',
    textAlign: 'center'
  },
  empty: {
    textAlign: 'center',
    padding: '30px'
  },
  emptyIcon: {
    fontSize: '2rem',
    display: 'block',
    marginBottom: '8px'
  },
  emptyText: {
    margin: 0,
    color: '#6c757d'
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  blocageItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    backgroundColor: '#fff8e1',
    borderRadius: '8px',
    border: '1px solid #ffe082'
  },
  badge: {
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    backgroundColor: '#ffc107',
    color: '#000',
    fontWeight: 'bold',
    fontSize: '0.9rem'
  },
  blocageInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
    flex: 1
  },
  prestationNumber: {
    fontWeight: '600',
    fontSize: '0.9rem',
    color: '#1a1a2e'
  },
  clientName: {
    fontSize: '0.85rem',
    color: '#6c757d'
  },
  date: {
    fontSize: '0.85rem',
    color: '#6c757d',
    marginLeft: 'auto'
  }
};

export default BlockedList;
